
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
import { Heading } from '@/components/Heading'
import { TipGood, TipBad } from '@/components/Tip'
import { CodeSample } from '@/components/CodeSample'
const Layout = _Layout;
const meta = {
  "id": "collection",
  "title": "Collections",
  "sidebar_label": "Collection"
};
const slug = 'collection';
const tableOfContents = [{
  "title": "Currently available collections",
  "slug": "currently-available-collections",
  "children": []
}, {
  "title": "On Roadmap",
  "slug": "on-roadmap",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">







    <p><a parentName="p" {...{
        "href": "https://developer.tradly.app/#1bb387a2-6328-4174-b542-8deac205ed19"
      }}>{`API REFERENCE`}</a>{`| `}<a parentName="p" {...{
        "href": "https://superadmin.tradly.app/collections"
      }}>{`Collection in SuperAdmin`}</a></p>
    <p>{`A collection widget/page is a feature that displays a group of accounts or listings on the home page of the app. This allows users to easily browse and discover new accounts or listings that they may be interested in.`}</p>
    <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/collection.png" />
    </div>
    <p>{`There are currently two types of collection widgets available:`}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Account Collection Widget: Displays a group of accounts (e.g. stores, profiles) based on a category.`}</li>
      <li parentName="ol">{`Listing Collection Widget: Displays a group of listings (e.g. ideas, postings, ads) based on a category.`}</li>
    </ol>
    <_Heading level={2} id={"currently-available-collections"} nextElement={{
      "type": "paragraph"
    }}>Currently available collections</_Heading>
    <p>{`In the current version of Tradly, the following types of collections are available: **`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Recent list of accounts/stores/profiles: `}</strong>{` This collection displays a list of the most recently created accounts on the platform. This could be useful for users who are looking for new stores or profiles to follow.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Recent list of listings/ideas/postings/ads: `}</strong>{` This collection displays a list of the most recently created listings on the platform. This could be useful for users who are looking for new products or ideas to explore.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Account collection widget based on category: `}</strong>{` This collection displays a list of accounts that are grouped by category. This could be useful for users who are looking for stores or profiles in a specific niche or industry.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Listing collection widget based on category: `}</strong>{` This collection displays a list of listings that are grouped by category. This could be useful for users who are looking for products or ideas in a specific niche or industry.`}</p>
      </li>
    </ul>
    <_Heading level={2} id={"on-roadmap"} nextElement={{
      "type": "paragraph"
    }}>On Roadmap</_Heading>
    <p>{`In future versions of Tradly, the following additional types of collections are planned: **`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Custom collections based on tags: `}</strong>{` This feature will allow platform administrators to create custom collections based on specific tags. This could be useful for creating themed collections or highlighting specific products or accounts.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Using attributes filter: `}</strong>{` This feature will allow users to filter collections based on specific attributes, such as color, size, or material. This could be useful for users who are looking for specific features in the products or accounts they are interested in.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Price: `}</strong>{` This feature will allow users to filter collections based on price ranges, such as less than $100, or greater than $500. This could be useful for users who are looking for products or accounts within a specific budget.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Offer percent: `}</strong>{` This feature will allow users to filter collections based on the percentage of discount offered on the products or accounts. This could be useful for users who are looking for deals or discounts.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Location: `}</strong>{` This feature will allow users to filter collections based on location, such as within a certain radius of their current location. This could be useful for users who are looking for stores or products in their local area.`}</p>
      </li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
